<script>
import featureFlag from '@/api/featureFlag';

const sendingPlaforms = {
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
};

export default {
  name: 'OtpMixin',
  data() {
    return {
      sendCodeViaSMS: false,
      voiceOtpEnabled: false,
      defaultSendPlatform: sendingPlaforms.WHATSAPP,
    };
  },
  async created() {
    const [smsTreatment, voiceTreatment] = await Promise.all([
      featureFlag.getAnonymousTreatment('sms-otp', '000'),
      featureFlag.getAnonymousTreatment('voice-otp', '000'),
    ]);
    this.sendCodeViaSMS = smsTreatment === 'on';
    this.voiceOtpEnabled = voiceTreatment === 'on';
  },
  methods: {
  },
  computed: {
    otpSentVia() {
      return this.sendCodeViaSMS ? 'בהודעה' : 'בוואטסאפ';
    },
    sendPlatform() {
      return this.sendCodeViaSMS ? sendingPlaforms.SMS : sendingPlaforms.WHATSAPP;
    },
  },
};

</script>
